/**
 * Scroll a horizontal product strip by roughly one viewport "page",
 * aligned to whole card steps for predictable arrow navigation.
 * @param {HTMLElement | null} scrollerEl
 * @param {1 | -1} direction
 */
export function scrollProductStripChunk(scrollerEl, direction) {
  if (!scrollerEl || !direction) return;
  const first = scrollerEl.querySelector(
    ".new-arrivals__item, .featured-collection__item, .home-shop-category__item"
  );
  if (!first) return;

  const style = window.getComputedStyle(scrollerEl);
  const gapRaw = style.gap || style.columnGap || "0";
  const gap = Number.parseFloat(gapRaw) || 0;
  const cardWidth = first.getBoundingClientRect().width;
  const step = cardWidth + gap;

  const singleStep = scrollerEl.dataset?.stripMode === "single-step";

  const approxFit = Math.max(1, Math.floor(scrollerEl.clientWidth / step));
  const cardsPerJump = singleStep
    ? 1
    : Math.min(Math.max(approxFit - 1, 1), 2);
  const chunk = step * cardsPerJump;

  // scrollerEl.scrollBy({
  //   left: direction * chunk,
  //   behavior: "smooth",
  // });

  scrollerEl.scrollBy({
  left: direction * step * 2,
  behavior: "smooth",
});
}
